<template>
  <div class="dash-root" :style="containerSize">
    <router-view :rem="rem" />
  </div>
</template>

<script>
import mixins from "@/utils/rem";

export default {
  name: "DashRoot",
  mixins: [mixins],
  created() {
    // 设计稿尺寸 1920×1080
    this.initRem(1920, 1080);
  }
};
</script>

<style lang="less" scoped>
.dash-root {
  overflow: hidden;
  color: #fff;
  background: #020b1e;
}
</style>
